import * as L from 'leaflet';
import { DataAtual } from '../functions/helper';
import ImgApicultor from '../components/LeafletMap/imagens_point/abelha.png';
import ImgMoradia from '../components/LeafletMap/imagens_point/moradia.png';
import ImgRetorno from '../components/LeafletMap/imagens_point/retorno.png';
import ImgSericicultura from '../components/LeafletMap/imagens_point/bicho.png';
import ImgAmoreira from '../components/LeafletMap/imagens_point/amoreira.png';
import ImgTemp from '../components/LeafletMap/imagens_point/temp.png';
import ImgCultura from '../components/LeafletMap/imagens_point/cultura.png';
import ImgAplicador from '../components/LeafletMap/imagens_point/aplicador.png';
import ImgAnimal from '../components/LeafletMap/imagens_point/animais.png';
import ImgReserva from '../components/LeafletMap/imagens_point/reserva.png';
import ImgRios from '../components/LeafletMap/imagens_point/rios.png';
import ImgEscola from '../components/LeafletMap/imagens_point/escola.png';

const iconeApicultor = L.icon({
  iconUrl: ImgApicultor,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [20, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeEscola = L.icon({
  iconUrl: ImgEscola,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [20, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeAnimal = L.icon({
  iconUrl: ImgAnimal,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [20, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeRios = L.icon({
  iconUrl: ImgRios,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [20, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeReserva = L.icon({
  iconUrl: ImgReserva,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [20, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeMoradia = L.icon({
  iconUrl: ImgMoradia,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeRetorno = L.icon({
  iconUrl: ImgRetorno,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeSericicultura = L.icon({
  iconUrl: ImgSericicultura,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeAmoreira = L.icon({
  iconUrl: ImgAmoreira,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeTemp = L.icon({
  iconUrl: ImgTemp,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeCultura = L.icon({
  iconUrl: ImgCultura,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});
const iconeAplicador = L.icon({
  iconUrl: ImgAplicador,
  iconSize: [42, 47], // size of the icon
  iconAnchor: [21, 47], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});

export const constantes = {
  aguardandoAtivacao: 'Aguardando Ativação',
  raiosExibicao: {
    cadastros: 10000,
    deriva: 10000,
  },
  tipoCadastro: [
    {
      valor: 'Temporário',
      description: 'Marcador Temporário',
      titulo: 'Marcador Temporário',
      value: 'Temporário',
      temporario: 'Temporário',
      tipo: 'marker',
      urlImg: ImgTemp,
      icone: iconeTemp,
      cor: '#0abde3',
      raio: 250,
    },
    {
      valor: 'Cultura Suscetível / Certificada',
      description: 'cultura',
      titulo: 'Cultura Suscetível / Certificada',
      value: 'Cultura Suscetível / Certificada',
      cultura: 'Cultura Suscetível / Certificada',
      tipo: 'poligon',
      urlImg: ImgCultura,
      icone: iconeCultura,
      cor: '#ff9f43',
      raio: 250,
    },
    {
      valor: 'Apicultura (Colmeias)',
      description: 'descricaoApicultura',
      value: 'Apicultura (Colmeias)',
      titulo: 'Apicultura (Colmeias)',
      apicultura: 'Apicultura (Colmeias)',
      tipo: 'marker',
      urlImg: ImgApicultor,
      icone: iconeApicultor,
      cor: '#feca57',
      raio: 250,
    },
    {
      valor: 'Bicho-da-seda (Sericicultura)',
      description: 'descricaoSericicultura',
      value: 'Bicho-da-seda (Sericicultura)',
      titulo: 'Bicho-da-seda (Sericicultura)',
      sericicultura: 'Bicho-da-seda (Sericicultura)',
      tipo: 'marker',
      urlImg: ImgSericicultura,
      icone: iconeSericicultura,
      cor: '#ee5253',
      raio: 250,
    },
    {
      valor: 'Aplicador de Defensivos / Produtor',
      description: 'tratamento',
      value: 'Aplicador de Defensivos',
      titulo: 'Aplicador de Defensivos',
      aplicador: 'Aplicador de Defensivos / Produtor',
      tipo: 'poligon',
      urlImg: ImgAplicador,
      icone: iconeAplicador,
      cor: '#f5f6fa',
      raio: 250,
    },
    {
      valor: 'Aplicador de Defensivos',
      description: 'tratamento',
      value: 'Aplicador de Defensivos',
      titulo: 'Aplicador de Defensivos',
      aplicador: 'Aplicador de Defensivos',
      tipo: 'poligon',
      urlImg: ImgAplicador,
      icone: iconeAplicador,
      cor: '#f5f6fa',
      raio: 250,
    },
    {
      valor: 'Agrupamento Animal',
      description: 'descricaoAgrupamento',
      value: 'Agrupamento Animal',
      titulo: 'Agrupamento de Animais',
      animal: 'Agrupamento Animal',
      tipo: 'marker',
      urlImg: ImgAnimal,
      icone: iconeAnimal,
      cor: '#006266',
      raio: 250,
    },
    {
      valor: 'App / Reserva Legal',
      description: 'descricaoReserva',
      value: 'App / Reserva Legal',
      titulo: 'App / Reserva Legal',
      reserva: 'App / Reserva Legal',
      tipo: 'marker',
      urlImg: ImgReserva,
      icone: iconeReserva,
      cor: '#006266',
      raio: 250,
    },
    {
      valor: 'Rio, Nascente',
      description: 'descricaoRios',
      value: 'Rio, Nascente',
      titulo: 'Rio, Nascente',
      rios: 'Rio, Nascente',
      tipo: 'marker',
      urlImg: ImgRios,
      icone: iconeRios,
      cor: '#006266',
      raio: 250,
    },
    {
      valor: 'Cultura de Amoreira',
      description: 'manejoAmoreira',
      value: 'Cultura de Amoreira',
      titulo: 'Cultura de Amoreira',
      amoreira: 'Cultura de Amoreira',
      tipo: 'poligon',
      urlImg: ImgAmoreira,
      icone: iconeAmoreira,
      cor: 'red',
      raio: 250,
    },
    {
      valor: 'Compra Segura',
      description: 'Local de Compra Segura',
      value: 'Compra Segura',
      titulo: 'Compra Segura',
      compra: 'Compra Segura',
      tipo: 'marker',
      urlImg: ImgRetorno,
      icone: iconeRetorno,
      cor: '#006266',
      raio: 250,
    },
    {
      valor: 'Escola',
      description: 'descricaoEscola',
      value: 'Escola',
      titulo: 'Escola',
      escola: 'Escola',
      tipo: 'marker',
      urlImg: ImgEscola,
      icone: iconeEscola,
      cor: '#006266',
      raio: 250,
    },
    {
      valor: 'Coleta',
      description: 'descricaoColeta',
      value: 'Coleta',
      titulo: 'Coleta',
      escola: 'Coleta',
      tipo: 'marker',
      urlImg: ImgRetorno,
      icone: iconeRetorno,
      cor: '#ff9f43',
      raio: 0,
    },
    {
      valor: 'Moradia Isolada',
      description: 'descricaoMoradia',
      value: 'Moradia Isolada',
      titulo: 'Moradia Isolada',
      moradia: 'Moradia Isolada',
      tipo: 'marker',
      urlImg: ImgMoradia,
      icone: iconeMoradia,
      cor: '#0652DD',
      raio: 250,
    },
  ],
  cadInitial: [
    {
      valor: 'Cultura Suscetível / Certificada',
      value: 'Cultura Suscetível / Certificada',
    },
    {
      valor: 'Apicultura (Colmeias)',
      value: 'Apicultura (Colmeias)',
    },
    {
      valor: 'Bicho-da-seda (Sericicultura)',
      value: 'Bicho-da-seda (Sericicultura)',
    },
    {
      valor: 'Aplicador de Defensivos',
      value: 'Aplicador de Defensivos',
    },
    {
      valor: 'Aplicador de Defensivos / Produtor',
      value: 'Aplicador de Defensivos',
    },
  ],
  classificacao:
    {
      temporario: 'Temporário',
      cultura: 'Cultura Suscetível / Certificada',
      apicultura: 'Apicultura (Colmeias)',
      sericicultura: 'Bicho-da-seda (Sericicultura)',
      aplicador: 'Aplicador de Defensivos',
      aplicadorProdutor: 'Aplicador de Defensivos / Produtor',
      animal: 'Agrupamento Animal',
      reserva: 'App / Reserva Legal',
      rios: 'Rio, Nascente',
      amoreira: 'Cultura de Amoreira',
      compra: 'Compra Segura',
      escola: 'Escola',
      coleta: 'Coleta',
      moradia: 'Moradia Isolada',
    },
  todos:
    {
      cultura: {
        valor: 'Cultura Suscetível / Certificada',
        tipo: 'poligon',
      },
      apicultura: {
        valor: 'Apicultura (Colmeias)',
        tipo: 'marker',
      },
      sericicultura: {
        valor: 'Bicho-da-seda (Sericicultura)',
        tipo: 'marker',
      },
      aplicador: {
        valor: 'Aplicador de Defensivos',
        tipo: 'poligon',
      },
      animal: {
        valor: 'Agrupamento Animal',
        tipo: 'marker',
      },
      reserva: {
        valor: 'App / Reserva Legal',
        tipo: 'marker',
      },
      rios: {
        valor: 'Rio, Nascente',
        tipo: 'marker',
      },
      amoreira: {
        valor: 'Cultura de Amoreira',
        tipo: 'poligon',
      },
      escola: {
        valor: 'Escola',
        tipo: 'marker',
      },
      coleta: {
        valor: 'Coleta',
        tipo: 'marker',
      },
      moradia: {
        valor: 'Moradia Isolada',
        tipo: 'marker',
      },
    },
};

export const baseParaCadastros = {
  active: false,
  celular: '', // celular de comunicação para whatsapp
  cidade: '', // cidade do cadastro
  dataAprov: '00/00/0000',
  dataCad: '00/00/0000',
  dataExp: '00/00/0000',
  estado: '', // Estado do cadastro
  fone: '', // Telefone usuário
  id: '', // identificação numéria de cadastro
  idUsuario: '', // id do usuário da conta
  nome: '', // Nome do Usuário da conta de cadastro
  obs: '', // Pode ser usada para a quantidade de colméias
  positions: [{}],
  proposito: '', // Hobby ou Comercial
  situacao: '', // Permanente ou Temporário
  tipo: '', // Aqui vai o tipo de cadastro,
  type: '', // Marker ou Poligono
  uid: '',
};
export const PERMITIDOS = [
  { permitido: { tipo: 'marker', valor: 'Moradia Isolada' } },
  { permitido: { tipo: 'marker', valor: 'Escola' } },
  { permitido: { tipo: 'marker', valor: 'Agrupamento Animal' } },
  { permitido: { tipo: 'marker', valor: 'Rio, Nascente' } },
  { permitido: { tipo: 'marker', valor: 'App / Reserva Legal' } },
];
export const TODOS_CADASTROS = [
  { valor: 'Aplicador de Defensivos' },
  { valor: 'Bicho-da-seda (Sericicultura)' },
  { valor: 'Cultura Suscetível / Certificada' },
  { valor: 'Apicultura (Colmeias)' },
];
export const PERMITIDOS_APLICADOR = [];

export const PERMITIDOS_SERICICULTOR = [
  { permitido: { tipo: 'poligon', valor: 'Cultura de Amoreira' } },
  { permitido: { tipo: 'marker', valor: 'Moradia Isolada' } },
  { permitido: { tipo: 'marker', valor: 'Escola' } },
  { permitido: { tipo: 'marker', valor: 'Agrupamento Animal' } },
  { permitido: { tipo: 'marker', valor: 'Rio, Nascente' } },
  { permitido: { tipo: 'marker', valor: 'App / Reserva Legal' } },
];

export const PERMITIDOS_APLICADOR_PRODUTOR = [
  { permitido: { tipo: 'marker', valor: 'Moradia Isolada' } },
  { permitido: { tipo: 'marker', valor: 'Escola' } },
  { permitido: { tipo: 'marker', valor: 'Agrupamento Animal' } },
  { permitido: { tipo: 'marker', valor: 'Rio, Nascente' } },
  { permitido: { tipo: 'marker', valor: 'App / Reserva Legal' } },
];
export const NOTIFICAO_PADRAO = {
  b: {
    body: 'Olá seja muito bem vindo a AGSAFE, é um prazer ter você aqui.',
    data: DataAtual(),
    read: false,
    title: 'Seja bem vindo a AGSAFE',
    uid: 'b',
  },
};

export const NOTIFICAO_APLICADOR_PRODUTOR = {
  b: {
    body: 'Olá seja muito bem vindo a AGSAFE, é um prazer ter você aqui. Verificamos que você é um Produtor Aplicador, por favor para que seja liberado seu cadastro de PRODUTOR nos informe via email info@agsafe.com.br ou WHATSAPP (48)9.9846-4966 seu CPF/CNPJ e qual a cultura que deseja para que façamos a liberação em seu cadastro.',
    data: DataAtual(),
    read: false,
    title: 'Seja bem vindo a AGSAFE',
    uid: 'b',
  },
};

export const RECORDS = {
  marker: [],
  poligon: [],
};
